import React from 'react';
import { PRODUCT_CATEGORY_ICON, SERVICE_ICONS } from '../../../../../../utils/constants/productCategoryIcon';
import { Container } from './styles';

type ResourceIconProps = {
  productIconName?: string;
  serviceName?: string;
};

const ResourceIcon: React.FC<ResourceIconProps> = ({ productIconName, serviceName }) => {
  let serviceIcon = null;
  let productIcon = null;
  if (productIconName) {
    productIcon = `https://agendamento-images-nprd.telemedicinaeinstein.com.br/icons/${productIconName}`;
  }

  if (serviceName) {
    serviceIcon = SERVICE_ICONS[serviceName] || PRODUCT_CATEGORY_ICON.APPOINTMENT.icon;
  }

  return (
    <Container>
      {productIcon ? (
        <div className="icon-wrapper">
          <img className="img-with-wrapper" src={productIcon} alt="an icon" />
        </div>
      ) : (
        <img src={serviceIcon || ''} alt={serviceName} />
      )}
    </Container>
  );
};

export default ResourceIcon;
